import React from 'react';
import Box from '@material-ui/core/Box';
import {Link} from 'react-router-dom';
import Button from '@material-ui/core/Button';
import {adminRoutes} from 'App/AppRouter/routes';
import './Toolbar.scss';

export default function UsersToolbar() {
    return (
        <Box className="toolbar">
            <Link
                className="toolbar__button-link"
                to={adminRoutes.appNameCreatePage}
            >
                <Button
                    className="toolbar__button"
                    variant="contained"
                >
                    ADD APP
                </Button>
            </Link>
        </Box>
    );
}
